import script from "./AppNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNav.vue?vue&type=script&setup=true&lang=js"

import "./AppNav.vue?vue&type=style&index=0&id=6cd80c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd80c4a"]])

export default __exports__